import React from "react";
import { t } from "ttag";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { SlideoverModal } from "../../SlideoverModal/SlideoverModal";
import { SpokeContributionsList } from "../SpokeContributionsList/SpokeContributionsList";
import { SuiteSummary } from "../SuiteSummary/SuiteSummary";
import type { Action, AppState } from "../engine";

import slideoverStyles from "../../SlideoverModal/SlideoverModal.module.scss";
import styles from "./MiniCart.module.scss";

/**
 * Mini cart overlay panel. Pure read view of `state.suite`. Per spec,
 * shown only mid-walk (Populated Landing already surfaces the same
 * content directly), with no Remove and no Add controls and empty
 * spokes omitted.
 */
export type MiniCartProps = {
    state: AppState;
    dispatch: React.Dispatch<Action>;
    isOpen: boolean;
    onClose: () => void;
    onShowOfferDetails: () => void;
};

export const MiniCart = ({
    state,
    dispatch,
    isOpen,
    onClose,
    onShowOfferDetails,
}: MiniCartProps) => {
    const contribs = state.suite.contributions;
    const suiteCount = contribs.length;

    return (
        <SlideoverModal
            isOpen={isOpen}
            onClose={onClose}
            theme="white"
            title={t`My Suite (${suiteCount})`}
            panelClassName={styles.panel}
        >
            <div
                className={concatClassNames([
                    slideoverStyles.body,
                    styles.body,
                ])}
                tabIndex={0}
                role="region"
                aria-label={t`Suite contents`}
            >
                {contribs.length === 0 ? (
                    <p className={styles.empty}>
                        {t`When you add products to your suite, they will show up here.`}
                    </p>
                ) : (
                    <SpokeContributionsList
                        suite={state.suite}
                        dispatch={dispatch}
                        mode="miniCart"
                    />
                )}
            </div>
            {contribs.length > 0 && (
                <SuiteSummary
                    suite={state.suite}
                    onShowSavingsDetails={onShowOfferDetails}
                    className={styles.footer}
                />
            )}
        </SlideoverModal>
    );
};
